<template>
  <Card theme="flat" class="integration-settings" :thumbnail="thumbnail.type === 'image' ? thumbnail.src : undefined">
    <template v-if="thumbnail.type === 'icon'" #header>
      <Icon :icon="thumbnail.src" size="3x" />
    </template>
    <template #default>
      <CustomFields v-model="data" :schema="schema" :validator="validator" />
    </template>
    <template #footer>
      <CheckboxComponent
        v-if="!status && gdpr && gdpr.consent"
        v-model="consent"
        :label="gdpr.consent"
        style="margin-right: auto"
        class="integration-settings__consent"
      />
      <div class="integration-settings__actions">
        <ButtonComponent
          v-if="!status && gdpr && gdpr.dpa"
          :icon="['fal', 'file-pdf']"
          tag="a"
          target="_blank"
          :href="gdpr.dpa"
          style="margin-right: auto"
          :label="$t('integrationDpaRecommendation')"
        />
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('cancel')" />
        <ButtonComponent
          :label="$t('confirm')"
          :promise="promise"
          :icon="['fal', 'angle-right']"
          theme="primary"
          :disabled="!validator.passes"
          @click="$emit('confirm', data)"
        />
      </div>
    </template>
  </Card>
</template>

<script>
import { Clone } from '@/utils'
import Validator from '@/mixins/validator-v2'

import Card from '@/components/Card'
import { CheckboxComponent } from 'vue-elder-checkbox'
import CustomFields, { getValidatorConfig } from '@kvass/custom-fields'

export default {
  mixins: [
    Validator({
      labels: 'validatorConfig.labels',
      rules: 'rules',
      data: 'dataComp',
    }),
  ],
  props: {
    value: Object,
    schema: Array,
    status: String,
    source: Object,
    gdpr: Object,
    promise: Promise,
  },
  watch: {
    value: {
      handler(val) {
        this.data = Clone(val)
      },
      immediate: true,
    },
  },
  data() {
    return {
      data: {},
      consent: false,
    }
  },
  computed: {
    thumbnail() {
      return {
        type: this.source.logo.match(/^[(https?:\/\\)\/]/) ? 'image' : 'icon',
        src: this.source.logo
      }
    },
    dataComp() {
      return {
        ...this.data,
        consent: this.consent,
      }
    },
    rules() {
      if (this.status || !this.gdpr || !this.gdpr.consent) return this.validatorConfig.rules
      return {
        ...this.validatorConfig.rules,
        consent: 'accepted',
      }
    },
    validatorConfig() {
      if (!this.schema || !this.schema.length) return {}
      return getValidatorConfig(this.schema, this.dataComp)
    },
  },
  components: {
    Card,
    CustomFields,
    CheckboxComponent,
  },
}
</script>

<style lang="scss">
.integration-settings {
  min-width: 500px;
  max-width: 720px;

  .custom-fields {
    gap: 0.5rem 1.5rem;
  }

  .custom-fields {
    margin-top: 0;
  }

  &__consent {
    font-size: 0.8em;
  }

  &__actions {
    display: flex;
    align-items: start;
    justify-content: end;
    gap: 1rem;
  }

  .card__header {
    min-height: 100px;

    .image {
      --image-size: contain !important;
      max-width: 200px;
      padding: inherit;
    }
  }

  .card__footer-content {
    flex-direction: column;
    gap: 2rem;
  }
}
</style>
